module.exports = __webpack_public_path__ + "static/media/Deal-Street-Asia.41b0d7e2.png";